"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidates the requests filed against a reservation, so a list refreshes
 * after one is created, edited or deleted from inside the reservation.
 */
export const useInvalidateWorkplaceRequestsByReservation = () => {
  const queryClient = useQueryClient();
  return useCallback(
    async (reservationId: string) => {
      await queryClient.invalidateQueries({
        queryKey: ["workplaceRequestsBySchedule", reservationId]
      });
    },
    [queryClient]
  );
};
